var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-tabs',{attrs:{"card":""},model:{value:(_vm.tabIndex),callback:function ($$v) {_vm.tabIndex=$$v},expression:"tabIndex"}},[_c('b-tab',{attrs:{"title":"Care Plans"}},[_c('call-table')],1),_c('b-tab',{attrs:{"title":"Manage"}},[_c('call-form')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }